module.exports = __webpack_public_path__ + "img/SAAS-mini.87ddfb69.png";